export const removeVehicleConfirmation = {
  title: 'Are you sure?',
  body: "You'll no longer receive value updates once you remove this vehicle.",
  confirmText: 'Yes, Remove Vehicle'
};
